import { useState } from "react";
import {useResetPassword} from '../hooks/useResetPassword';


const ResetPasswordPage = () => {
    const [resetCode, setResetCode] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const {resetPassword, error, isLoading} = useResetPassword();

    const handleSubmit = async (e) => {
        e.preventDefault()

        await resetPassword(resetCode, email, password, confirmPassword);
    }

    return (
        <form className="login" onSubmit={handleSubmit}>
            <h3>Reset Password</h3>
            <div className="inner-auth-form-container">
                <label>Reset Code</label>
                <input 
                    type="text"
                    onChange={(e) => setResetCode(e.target.value)}
                    value={resetCode}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Email</label>
                <input 
                    type="text"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>New Password</label>
                <input 
                    type="password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                />
            </div>
            <div className="inner-auth-form-container">
                <label>Confirm New Password</label>
                <input 
                    type="password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    value={confirmPassword}
                />
            </div>
            <button type="submit" className="btn btn-light" disabled={isLoading}>Log In</button>
            {error && <div className="error">{error}</div> }
        </form>
    )
}

export default ResetPasswordPage;